import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function AnnouncementUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("working");

  const set = (action) => {
    setState("working");
    api.post(`/announcements/${action}/${token}`)
      .then(({ data }) => setState(data.announcement_emails ? "subscribed" : "unsubscribed"))
      .catch(() => setState("invalid"));
  };

  useEffect(() => { set("unsubscribe"); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-ivory grid place-items-center p-6">
      <div className="card-base p-8 max-w-md w-full space-y-4 text-center" data-testid="unsubscribe-page">
        <div className="label-overline">AMDS announcements</div>
        {state === "working" && <p className="text-ink-600">One moment…</p>}
        {state === "unsubscribed" && (
          <>
            <h1 className="font-heading text-2xl font-bold" data-testid="unsubscribe-done">You're unsubscribed</h1>
            <p className="text-sm text-ink-600">You won't get announcement emails any more. Dep requests, booking and account emails will still arrive.</p>
            <button className="btn-secondary" onClick={() => set("resubscribe")} data-testid="unsubscribe-undo">Subscribe again</button>
          </>
        )}
        {state === "subscribed" && (
          <>
            <h1 className="font-heading text-2xl font-bold" data-testid="resubscribe-done">You're subscribed again</h1>
            <p className="text-sm text-ink-600">You'll receive AMDS announcements by email.</p>
          </>
        )}
        {state === "invalid" && <p className="text-ink-600" data-testid="unsubscribe-invalid">This link isn't valid. You can change this anytime in your Profile.</p>}
        <Link to="/" className="text-sm text-sage-600 font-semibold block pt-2" data-testid="unsubscribe-home-link">Go to AMDS</Link>
      </div>
    </div>
  );
}
